<template>
  <VModal disable-backdrop-click :disable-close="false" @close="$emit('close')">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full max-w-3xl h-full mx-auto">
        <div class="rounded shadow-lg bg-gray-100 overflow-hidden h-full flex flex-col">
          <div class="px-4 sm:px-6 py-5 border-b flex-none">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Bounce logs</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 bg-white overflow-auto">
            <ul class="divide-y">
              <li
                v-for="bounceLog in emailMessageTrackingLog.bounce_logs"
                :key="bounceLog.id"
                class="px-4 sm:px-6 py-3 sm:py-5"
              >
                <BounceLogListLine :bounce-log="bounceLog" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import BounceLogListLine from './BounceLogListLine.vue';

export default {
  components: { BounceLogListLine },
  props: {
    emailMessageTrackingLog: {
      type: Object,
      required: true,
    },
  },
};
</script>
